<eiq-button
  [color]="displayColor$()"
  [disabled]="disabled()"
  [icon]="icon()"
  [iconPosition]="iconPosition()"
  [size]="size()"
  [testId]="testId()"
  [expand]="expand()"
  [text]="displayText$()"
  [style]="style()"
  (clicked)="onClick()"
>
</eiq-button>
